import './ComingSoon.css'
import HeaderNew from '../Layout/Header/Header'
const ComingSoon = () => {
    return (
        <div>
            <HeaderNew/>
            <div class="coming-soon">
                <h1>coming soon<span class="dot">.</span></h1>
                <p> We're working hard to bring you something amazing. Stay tuned!</p>
            </div>
        </div>
    )
}

export default ComingSoon